<div class="container">
  <div class="container__section">
    <app-links></app-links>
  </div>
</div>
